export var RatingTypeEnum;
(function (RatingTypeEnum) {
    RatingTypeEnum["shortText"] = "TEXT_300";
    RatingTypeEnum["longText"] = "TEXT_1000";
    RatingTypeEnum["shortRating"] = "RATING_1_5";
    RatingTypeEnum["longRating"] = "RATING_1_10";
    RatingTypeEnum["singleChoice"] = "SINGLE_CHOICE";
    RatingTypeEnum["multipleChoice"] = "MULTIPLE_CHOICE";
})(RatingTypeEnum || (RatingTypeEnum = {}));
